/**
 * Status Badge Component
 * Displays delivery status with appropriate color coding
 */

interface StatusBadgeProps {
  status: string;
}

const STATUS_COLORS: Record<string, { bg: string; text: string }> = {
  PENDING: { bg: 'bg-yellow-100', text: 'text-yellow-800' },
  SCHEDULED: { bg: 'bg-blue-100', text: 'text-blue-800' },
  RESCHEDULED: { bg: 'bg-blue-100', text: 'text-blue-800' },
  IN_TRANSIT: { bg: 'bg-purple-100', text: 'text-purple-800' },
  DELIVERED: { bg: 'bg-green-100', text: 'text-green-800' },
  COMPLETED: { bg: 'bg-green-100', text: 'text-green-800' },
  FAILED: { bg: 'bg-red-100', text: 'text-red-800' },
  CANCELLED: { bg: 'bg-gray-100', text: 'text-gray-800' },
};

export function StatusBadge({ status }: StatusBadgeProps) {
  const colors = STATUS_COLORS[status] || STATUS_COLORS.PENDING;

  return (
    <span className={`px-3 py-1 rounded-full text-sm font-medium ${colors.bg} ${colors.text}`}>
      {status}
    </span>
  );
}
